// GENERATED by `pnpm features gen` from features/*/ui/index.ts. Do not edit: `pnpm features check` (F02) fails when it is stale.
import type { FeatureUi } from './kit/index.ts';
import { ui as crm } from '../../../features/crm/ui/index.ts';
import { ui as feedback } from '../../../features/feedback/ui/index.ts';

export const uiParts = [crm, feedback] as const satisfies readonly FeatureUi[];
